import { EntitlementType } from '@dreryk/drerykweb-medical-dictionaries-api';
import { PatientEntitlementType } from '@dreryk/egabinet-patient-frontend-api';

import { Range } from '@dreryk/watermelon';
import { assertUnreachable } from '@dreryk/react-common';

import {
   EntitlementDocumentDateRange,
   ValidityDateRangeFormValue,
   ValidityDateRangeValue,
} from './patientEntitlements.types';
import { isPregnancyDateRange } from './confirmingDocument/PregnancyDateFields/PregnancyDateFields.utils';

const isEntitlementDocumentDateRange = (value: unknown): value is EntitlementDocumentDateRange => {
   return typeof value === 'object' && value !== null && 'issueDate' in value;
};

export const mapPatientEntitlementTypeToEntitlementType = (
   patientEntitlementType: PatientEntitlementType
): EntitlementType => {
   switch (patientEntitlementType) {
      case 'ARMY_DISABLED':
         return 'IW';
      case 'WAR_DISABLED':
         return 'IB';
      case 'BLOOD_DONOR':
         return 'ZK';
      case 'INJURED_VETERAN':
         return 'WE';
      case 'PREGNANCY':
         return 'C';
      default:
         return assertUnreachable(patientEntitlementType);
   }
};

export const toValidityDateRangeValue = (value: ValidityDateRangeFormValue): ValidityDateRangeValue => {
   if (!value) {
      return null;
   }

   if (isPregnancyDateRange(value) && value.start && value.end) {
      return Range.closed(value.start, value.end);
   }

   if (isEntitlementDocumentDateRange(value)) {
      if (value.issueDate && value.validityDate) {
         return Range.closed(value.issueDate, value.validityDate);
      }
      if (value.issueDate) {
         return Range.atLeast(value.issueDate);
      }
      return null;
   }

   return (value as ValidityDateRangeValue) ?? null;
};
